import { render, staticRenderFns } from "./activityList.vue?vue&type=template&id=5af78d60&scoped=true"
import script from "./activityList.vue?vue&type=script&lang=js"
export * from "./activityList.vue?vue&type=script&lang=js"
import style0 from "./activityList.vue?vue&type=style&index=0&id=5af78d60&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af78d60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5af78d60')) {
      api.createRecord('5af78d60', component.options)
    } else {
      api.reload('5af78d60', component.options)
    }
    module.hot.accept("./activityList.vue?vue&type=template&id=5af78d60&scoped=true", function () {
      api.rerender('5af78d60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/activityList.vue"
export default component.exports